export default __webpack_public_path__ + "9b9a619f3dec832b7cd7991af7ff0d8b.png";